import { Mutation } from '@apollo/client/react/components';
import * as React from 'react';
import GroupOptionsCheckbox from '../GroupOptionsCheckbox';
import SET_CLASS_VISIBILITY from 'groups/components/mutations/setClassVisibility.gql';
import ToastActions from 'actions/ToastActions';
import { ApolloError } from '@apollo/client';
import { setClassVisibilityVariables } from 'groups/components/mutations/__generated__/setClassVisibility';

type Props = {
  checked: boolean;
  classSearchabilitySchoolDefault: string;
  searchable: boolean; // old
  onChange: (event: React.MouseEvent, setClassVisibility?: any) => void;
  disabled: boolean;
};

const GroupOptionsClassSearchabilityCheckbox = ({
  checked,
  classSearchabilitySchoolDefault,
  onChange,
  disabled,
}: Props) => {
  return (
    <Mutation
      mutation={SET_CLASS_VISIBILITY}
      onCompleted={() => ToastActions.showSuccessToast('Saved')}
      onError={(error: ApolloError) => ToastActions.showErrorToast(error.message)}
    >
      {(setClassVisibility: (input: { variables: setClassVisibilityVariables }) => void) => (
        <GroupOptionsCheckbox
          label="Class visibility"
          sublabel="This class will appear in class search and on your profile."
          checked={checked}
          schoolDefault={classSearchabilitySchoolDefault}
          onChange={(event) => onChange(event, setClassVisibility)}
          disabled={disabled}
        />
      )}
    </Mutation>
  );
};

export default GroupOptionsClassSearchabilityCheckbox;
